<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-primary)]">
    <template #right>
      <RouterLink
        class="h-full block bg-no-repeat bg-cover bg-center"
        :style="{ width: '50vw', backgroundImage: `url(${authVisual})` }"
        to="/"
        aria-label="Visit homepage"
      />
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center">
        <div class="w-full max-w-[420px] rounded-2xl bg-[var(--va-background-secondary)] shadow-lg p-8">
          <RouterView />
        </div>
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-primary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-start w-full">
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <img
                v-if="currentPresetName === 'dark'"
                src="../components/navbar/bragg_logo-white-rgb.svg"
                alt="Bragg Logo"
                class="mb-2"
                style="height: 70px"
              />
              <img
                v-else
                src="../components/navbar/bragg_logo-black-rgb.svg"
                alt="Bragg Logo"
                class="mb-2"
                style="height: 70px"
              />
            </RouterLink>
            <div class="w-full rounded-2xl bg-[var(--va-background-secondary)] shadow-lg p-6">
              <RouterView />
            </div>
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint, useColors } from 'vuestic-ui'
import authVisual from '../assets/images/auth-visual.png'

const breakpoint = useBreakpoint()
const { currentPresetName } = useColors()
</script>

<style scoped>
:deep(.va-input-label) {
  text-transform: none;
  font-weight: 600;
  color: var(--va-text-primary) !important;
}

:deep(.va-button) {
  --button-primary-brand-bg: #0016eb;
  --va-background-color: var(--button-primary-brand-bg) !important;
}
</style>
